import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.css';

// Keep await inside a function: iOS 14 WebViews cannot parse top-level await.
async function bootstrap() {
  const isPlanPath = window.location.pathname === '/plans'
    || window.location.pathname.startsWith('/plans/');

  let Root: React.ComponentType;
  if (isPlanPath) {
    const { bootstrapPlanH5Session } = await import('./lib/auth/planH5Session');
    await bootstrapPlanH5Session();
    Root = (await import('./features/plans/PlanStandaloneApp')).default;
  } else {
    const [{ bootstrapQuizWebViewSession }, { applyInitialTheme }] = await Promise.all([
      import('./features/quiz/learner/quizWebViewBootstrap'),
      import('./lib/store/app'),
    ]);
    await bootstrapQuizWebViewSession();
    applyInitialTheme();
    Root = (await import('./App')).default;
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <Root />
      </BrowserRouter>
    </React.StrictMode>,
  );
}

void bootstrap().catch(() => {
  const root = document.getElementById('root');
  if (!root) return;
  const message = document.createElement('p');
  message.textContent = '页面加载失败，请退出后重新进入。';
  message.setAttribute('role', 'alert');
  root.replaceChildren(message);
});
